import { Eye } from '@tmov/design-system/icons';
import { notification, Tooltip } from 'antd';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import { formatarData } from '../../../../../helpers/data';
import {
  formatarPlaca,
  formatarTonelada,
} from '../../../../../helpers/formatador';
import { useAuth } from '../../../../../security/authContext';
import { checkPermission } from '../../../../../security/Can';
import apiNetCore from '../../../../../services/apiNetCore';
import colors from '../../../../../styles/colors';
import { Spin } from '../../../../../styles/global';
import StatusMotoristaEnum from '../../../Enum/StatusMotoristaEnum';
import TipoDirecionamentoEnum from '../../../Enum/TipoDirecionamentoEnum';
import { Tag } from '../../Lotes/styles';
import TagButton from './components/TagButton';
import { DrawerFiltro } from './DrawerFiltro';
import { DrawerTracking } from './DrawerTracking';
import {
  Container,
  FiltroData,
  IconButton,
  SubTitle,
  Tabela,
  TabelaHeader,
} from './styles';

const TabelaMotoristas = ({
  detalhesDemanda,
  motoristas,
  setMotoristas,
  loading,
  anexoNfe,
}) => {
  const { user } = useAuth();
  const { lotes } = detalhesDemanda;
  const [dadosMotorista, setDadosMotorista] = useState();
  const [trackingDetails, setTrackingDetails] = useState([]);
  const [loadingDrawer, setLoadingDrawer] = useState({});
  const [documentosMotorista, setDocumentosMotorista] = useState([]);
  const [openDrawerFiltro, setOpenDrawerFiltro] = useState(false);
  const [openDrawerTracking, setOpenDrawerTracking] = useState(false);

  const handleDocumentos = async idLoteConjunto => {
    try {
      const { data: documentos } = await apiNetCore.get(
        `/LoteConjunto/${idLoteConjunto}/documentos`
      );

      if (documentos) setDocumentosMotorista(documentos);
    } catch (err) {
      notification.warning({
        message: 'Ops, não foi possível localizar os dados de documentos',
        description: 'Dados de documentos não disponível',
      });
    }
  };

  const handleTrackingDetails = async IdLoteConjunto => {
    const response = await apiNetCore.post(
      `/tracking/detalhes-motorista?idLoteConjunto=${IdLoteConjunto}`
    );

    if (response.status === 200) {
      setTrackingDetails(response.data);
    }
  };

  const handleShowDrawerTracking = async (motorista, index) => {
    try {
      setLoadingDrawer({ ...loadingDrawer, [index]: true });
      if (motorista) {
        await Promise.all([
          handleTrackingDetails(motorista.IdLoteConjunto),
          handleDocumentos(motorista.IdLoteConjunto),
        ]);
        setDadosMotorista(motorista);
        setOpenDrawerTracking(true);
      }
    } catch (err) {
      notification.warning({
        message:
          'Ops, não foi possível localizar os dados de tracking dessa viagem',
        description: 'Tracking de viagem não disponível',
      });
    } finally {
      setLoadingDrawer({ ...loadingDrawer, [index]: false });
    }
  };

  const handleCloseDrawer = () => {
    setDadosMotorista(null);
    setDocumentosMotorista([]);
    setOpenDrawerTracking(prevState => !prevState);
  };

  const isMarketplace = tipo => tipo === TipoDirecionamentoEnum.MARKETPLACE;

  const transportadoras = lotes
    .map(lote => ({
      id: lote.idLote,
      idTransportadora: lote.idTransportadora,
      razao: lote.razaoSocialTransportadora,
    }))
    .filter(lote => lote.idTransportadora !== null);

  return (
    <Container>
      {dadosMotorista && (
        <DrawerTracking
          dadosMotorista={dadosMotorista}
          trackingDetails={trackingDetails}
          documentosMotorista={documentosMotorista}
          transportadoras={transportadoras}
          onClose={handleCloseDrawer}
          visivel={openDrawerTracking}
        />
      )}
      <DrawerFiltro
        transportadoras={transportadoras}
        onClose={setOpenDrawerFiltro}
        visivel={openDrawerFiltro}
      />
      <TabelaHeader>
        <p>
          <b>Lista de motoristas</b>
        </p>
        <FiltroData onClick={() => setOpenDrawerFiltro(true)}>
          Filtrar
        </FiltroData>
      </TabelaHeader>
      <Tabela>
        <tr>
          <th>Status</th>
          <th>Motorista</th>
          <th>Placa</th>
          <th>Peso</th>
          <th>Transportadora</th>
          <th>Data Carregamento</th>
        </tr>
        {loading ? (
          <Spin style={{ width: '100%', margin: '50px 0' }} />
        ) : (
          motoristas &&
          motoristas.map((motorista, index) => (
            <tr key={motorista.IdLoteConjunto}>
              <td>
                {checkPermission(user.permissions, 'motorista-status:all') ? (
                  <TagButton
                    detalhesDemanda={detalhesDemanda}
                    initialStatusInt={motorista.StatusInt}
                    idLoteConjunto={motorista.IdLoteConjunto}
                    isTransportadoraExterna={motorista.IsTransportadoraExterna}
                    tagMotorista={motorista}
                    setMotoristas={setMotoristas}
                    anexoNfe={anexoNfe}
                  />
                ) : (
                  <Tag
                    color={
                      StatusMotoristaEnum.getTipo(motorista.StatusInt)
                        .background
                    }
                    texto={
                      StatusMotoristaEnum.getTipo(motorista.StatusInt).textColor
                    }
                  >
                    {motorista.Status}
                  </Tag>
                )}
              </td>
              <td>{motorista.Nome}</td>
              <td>{formatarPlaca(motorista.PlacaCavalo)}</td>
              <td>{formatarTonelada(motorista.Peso)}</td>
              <td style={{ width: 'fit-content' }}>
                <Tooltip
                  title={
                    isMarketplace(motorista.TipoDirecionamento)
                      ? 'TMOV'
                      : motorista.NomeTransportadora
                  }
                >
                  <SubTitle>
                    {isMarketplace(motorista.TipoDirecionamento)
                      ? 'TMOV'
                      : motorista.NomeTransportadora}
                  </SubTitle>
                </Tooltip>
              </td>
              <td>
                {motorista.DataEmissaoCte
                  ? formatarData(motorista.DataEmissaoCte)
                  : `(${motorista.EntradaFila.slice(0, 10)})`}
              </td>
              <td
                style={{
                  justifyContent: 'flex-end',
                }}
              >
                {loadingDrawer[index] ? (
                  <div
                    style={{
                      alignItems: 'center',
                      marginRight: '10px',
                    }}
                  >
                    <Spin />
                  </div>
                ) : (
                  <IconButton
                    style={{ marginLeft: '50px' }}
                    data-testid="detalhes-motorista"
                    onClick={() => handleShowDrawerTracking(motorista, index)}
                    disabled={
                      motorista.StatusInt === StatusMotoristaEnum.REMOVIDO
                    }
                  >
                    <Eye color={colors.tmov_green} aria-label="download" />
                  </IconButton>
                )}
              </td>
            </tr>
          ))
        )}
      </Tabela>
    </Container>
  );
};

const endereco = PropTypes.shape({
  bairro: PropTypes.string,
  cep: PropTypes.string,
  cidade: PropTypes.string,
  cnpj: PropTypes.string,
  complemento: PropTypes.string,
  endereco: PropTypes.string,
  estado: PropTypes.string,
  ibgeCidade: PropTypes.number,
  idCidade: PropTypes.number,
  idCliente: PropTypes.number,
  idClienteEndereco: PropTypes.number,
  idEstado: PropTypes.number,
  nomeCliente: PropTypes.string,
  numero: PropTypes.number,
});

TabelaMotoristas.propTypes = {
  detalhesDemanda: PropTypes.shape({
    enderecoDestino: PropTypes.arrayOf(endereco),
    enderecoExpedidor: PropTypes.arrayOf(endereco),
    enderecoOrigem: PropTypes.arrayOf(endereco),
    enderecoRecebedor: PropTypes.arrayOf(endereco),
    razaoSocialClientePagador: PropTypes.string,
    lotes: PropTypes.arrayOf({
      idTransportadora: PropTypes.number,
      razaoSocialTransportadora: PropTypes.string,
      tipoDirecionamento: PropTypes.number,
    }),
  }),
  motoristas: PropTypes.arrayOf(
    PropTypes.shape({
      IdLoteConjunto: PropTypes.number,
      dFilial: PropTypes.number,
      ClassificacaoMotorista: PropTypes.number,
      EntradaFila: PropTypes.string,
      EntradaFilaData: PropTypes.string,
      Nome: PropTypes.string,
      PlacaCavalo: PropTypes.string,
      Status: PropTypes.string,
      StatusInt: PropTypes.number,
      TipoDirecionamento: PropTypes.number,
    })
  ),
  setMotoristas: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  anexoNfe: PropTypes.bool.isRequired,
};

TabelaMotoristas.defaultProps = {
  detalhesDemanda: null,
  motoristas: [],
};

export { TabelaMotoristas };
